<!-- NOTE THIS IS USED ONLY FOR DEVELOPMENT -->

<template>
  <section class="login-page app-content d-flex align-items-center">
    <div class="container">
      <div class="row justify-content-center">
          <div class="form-container">
            <h2>Teacher login</h2>
            <form @submit.prevent="submit" id="login-form" class="auth-form">
              <alert :success="alert.success" :error="alert.error">
                <div v-if="alert.error">
                  Invalid credentials.
                  <br/>
                  Make sure you first authorized your account here:
                  <br/>
                  <a href="https://t1.mogree.com/web/edugroup/secure/" target="_blank">https://t1.mogree.com/web/edugroup/secure/</a>
                </div>
              </alert>
              <div class="form-group">
                <form-error :errors='errors' :attribute="'email'">
                  <input v-model="user.mail"  placeholder="Email"/>
                </form-error>
                <input v-model="pinboard"  placeholder="Pinboard id"/>
                <i class="fa fa-user"></i>
              </div>
              <button class="btn-submit" type="submit" form="login-form" value="Submit" :disabled="processing">
                <clip-loader :loading="processing" :color="'white'" :size="'17px'"></clip-loader>
                <span v-if="!processing">Anmelden</span>
              </button>
            </form>
          </div>
      </div>
    </div>
  </section>
</template>

<script>
import account from '@/api/v1/account';
import Alert from '@/components/Helpers/Alert';
import FormError from '@/components/Helpers/FormError';
// Mixins
import alert from '@/mixins/alert';

export default {
  components: { Alert, FormError },
  mixins: [alert],
  data() {
    return {
      user: {
        teacher: true,
      },
      pinboard: '',
      processing: false,
    };
  },
  methods: {
    submit() {
      this.clearAlerts();
      this.processing = true;
      const succ = () => { this.alert.success = 'Success!'; this.processing = false; };
      const err = (response) => {
        this.alert.error = response.errormessage; this.processing = false;
      };
      account.shibboleth(this.user, this.pinboard, succ, err);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Auth/TeacherLogin.vue